import './LoadingSpinner.scss';
import * as React from 'react';
import { IconLoader } from 'src/components/Icon/IconLoader';

export function LoadingSpinner(): JSX.Element {
    return (
        <div className="lvo-loading-spinner">
            <IconLoader/>
        </div>
    );
}
